import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { CustomClub } from '../../../components/Club/Club';
import FloatButton from '../../../components/FloatButton/FloatButton';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import CustomList from '../../../components/List/CustomList';
import useSearchParam from '../../../hooks/useQueryParams';
import { Club as ClubModel } from '../../../models/club';
import { PaginatedResult } from '../../../models/common/paginate';
import { getAllClub } from '../../../service/clubs';

import { useUserStore } from '../../../store/useUser';
import { main_color_50 } from '../../../styles/_variables';

import styles from './ClubList.module.scss';
import useHeader from '../../../hooks/useHeader';

const ClubList = () => {
  const navigate = useNavigate()
  
  const [page, setPage] = useSearchParam<number, any>('page');
  
  const userId = useUserStore(state => state.id)
  const profile = useUserStore(state => state.profile)
  
  useHeader({ header: 'Clubes' });

  const {data: clubs, isFetching} = useQuery(
    ['clubs', page],
    () => getAllClub(page),
    {refetchOnMount: 'always', staleTime: 0,keepPreviousData: true, refetchOnWindowFocus: false},
  );

  useEffect(() => {
    if(!page) setPage(0)
  }, [page, setPage])

  const addNewClub = (e) => {
    navigate('/club/add');
  }

  return (
      <div className={styles.container}>
        <HeaderPage header="Clubes" bageColor={main_color_50}/>
        <div className={styles.clubsContainer}>
          <CustomList<ClubModel> 
            data={clubs?.data || []}
            loadMoreText={"Buscar mais clubes"}
            total={clubs?.total}
            lastPage={clubs?.last_page}
            key="id"
            isLoading={isFetching}
            render={(club)=> <CustomClub club={club} key={club?.id}/>}
            />
        </div>
        { 
          userId && profile !== 'Clubista' ? 
          <FloatButton onClick={addNewClub}/> : null
        }
      </div>
  )
}

export default ClubList;